module.exports = __webpack_public_path__ + "assets/media/evening.5e614b18.mp3";